import $ from 'jquery';
import slick from 'slick-carousel';
import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';
import 'isotope-packery';
import fitvids from 'fitvids';
jQueryBridget( 'isotope', Isotope, $ ); 

/**
 * Variables
 */
 
const windowWidth = $(window).width();
const isDesktop = windowWidth <= 1200;
const isMd = windowWidth <= 1025;
const isTablet = windowWidth <= 768;
const isMobile = windowWidth <= 480;


/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
  event.preventDefault();
  $('.js-menu-toggle, .nav--header, .header__navigation').toggleClass('open');
  $('.header').toggleClass('menu-open');
};

$('.js-menu-toggle').on('click', toggleMenu);

/* *
 * Slick Slider
 * */
 
$('[data-slider="testimonials"]').slick({
  slidesToShow: 1,
  arrows: true,
  dots: true,
  autoplay: false,
  speed: 1000,
  autoplaySpeed: 7000,
  cssEase: 'ease-out',
});

$('[data-slider="latest_posts"]').slick({
  slidesToShow: 1,
  arrows: false,
  dots: false,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 5000,
  cssEase: 'ease-out',
  fade: true,
});

$('[data-title]').on('click', function(e) {
  e.preventDefault();
  var parent = $(this).parent();
  var slideIndex = $(this).data('title');
  $('.latest-posts__nav').removeClass('active');
  $(this).addClass('active');
  $('[data-slider]').slick('slickGoTo', parseInt(slideIndex) );
});

$('.slider').on('afterChange', function(event, slick, currentSlide, nextSlide){ 
  var target = $('.latest-posts__nav[data-title="' + currentSlide + '"]');
  target.addClass('active');
  $('[data-title]').not(target).removeClass('active');
});

/* *
 * Nav Panel
 * */

if ( !isMd )
{
  var timer;
  var delay = 300;

  $('.mega-menu').hover(function() {

  const $this = $(this);
  const title = $(this).find('a').attr('title');
  var target = $('[data-nav="'+ title +'"]');

    timer = setTimeout(function() {
      $this.addClass('active').siblings().removeClass('active');
      target.addClass('active');
      $('[data-nav]').not(target).removeClass('active').fadeOut();
    }, delay);

    }, function() {
      clearTimeout(timer);
  });

  $('[data-nav]').on( 'mouseleave', function(e) {
    $(this).removeClass('active');
    $('.nav--header li').removeClass('active');
  });

  $('.nav--header li').on( 'mouseover', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('active'))
    {
      $('[data-nav]').removeClass('active');
      $('.nav--header li').removeClass('active');
    }
  });
}

if ( isMd )
{
  $('.mega-menu > a').on( 'click', function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $(this).addClass('active');
    $(this).parent().toggleClass('open').siblings().removeClass('open');
    var sub_menu = $(this).parent().find('.sub-menu');

    if ( sub_menu.hasClass('open') || !sub_menu.length )
    {
      location.href = href;
    }

    sub_menu.slideToggle().addClass('open');
    $('.sub-menu').not(sub_menu).slideUp();

  });
}

/* *
 * History navigation
 * */

$('.nav__step').on('click', function(e) {
  e.preventDefault();
  var tab = $(this).data('step');
  var target = $('[data-step="' + tab + '"]');
  target.addClass('active');
  $('[data-step]').not(target).removeClass('active');

});

$('.nav__arrow--left').on('click', function() {

  var step = $('.history-slider__nav').find('.nav__step.active');
  var tab = $(step).data('step');
  var minus = tab - 1;
  var current = $('[data-step="' + tab + '"]');
  var target = $('[data-step="' + minus + '"]');

  if (tab != 1)
  {
    target.addClass('active');
    $('[data-step]').not(target).removeClass('active');
  };
  
});

$('.nav__arrow--right').on('click', function() {

  var step = $('.history-slider__nav').find('.nav__step.active');
  var end = $('.history-slider__nav').find('.nav__step').last();
  var end_tab = $(end).data('step');

  if (!step)
  {
    var step = $('.history-slider__nav').find('.nav__step').first();
  }
  
  var tab = $(step).data('step');

  if (!tab)
  {
    var tab = 1;
  }

  var add = tab + 1;
  var current = $('[data-step="' + tab + '"]');
  var target = $('[data-step="' + add + '"]');

  if (tab != end_tab)
  {
    target.addClass('active');
    $('[data-step]').not(target).removeClass('active');
  }
  
});

/**
 * Insights Dropdown
 */

$('.filter__dropdown .filter__placeholder').on( 'click', function(e) {
  e.preventDefault();
  var parent = $(this).parent();
  var target = parent.find('.dropdown__inner');
  target.slideToggle();
});

/**
 * Partner Modal
 */

$('.partner__header .h3').on( 'click', function(e) {
  e.preventDefault();
  var partner = $(this).data('partner');
  var target = $('[data-modal="'+ partner +'"]');
  target.addClass('active').fadeIn();
  $('.body__overlay').fadeIn();
});

$('.body__overlay').on( 'click', function(e) {
  e.preventDefault();
  var target = $('[data-modal]');
  target.removeClass('active').fadeOut();
  $('.body__overlay').fadeOut();
});

/**
 * Search bar
 */

$('.search-icon').on('click', function() {
  $('.search-bar').slideToggle();
  $('[data-nav]').removeClass('active');
  $('.nav--header li').removeClass('active');
});

$('.search-icon--footer').on( 'click', function() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  if ($('.search-bar').show())
  {
    $('.search-bar').slideDown();
  }
});

/**
 * Search Tabs
 */

$('.search__nav [data-tab]').on( 'click', function(e) {
  e.preventDefault();
  var tab = $(this).data('tab');
  var target = $('[data-content="' + tab + '"]')

  if ( !$(this).hasClass('tab--active') )
  {
    $(this).addClass('tab--active');
    $('[data-tab]').not(this).removeClass('tab--active');
  }

  target.addClass('active');
  $('[data-content]').not(target).removeClass('active');

});

/**
 * Partner Filter
 */

$('[data-filter-option]').on('click', function() {
  $(this).toggleClass('active');
  $('[data-filter-option]').not(this).removeClass('active');
  var option = $(this).data('filter-option');
  var target = $('[data-tab-content="' + option + '"]');
  target.toggleClass('active').slideToggle();
  $('[data-tab-content]').not(target).removeClass('active').slideUp();
});

/**
 * Isotope Grid Filter 
 */

var $isotopeContainer;

$(window).on( 'load', function() {

  if ($('#map').length)
  {

  var style = [ { "featureType": "administrative", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [ { "saturation": "-100" }, { "lightness": "57" } ] }, { "featureType": "poi", "elementType": "geometry.stroke", "stylers": [ { "lightness": "1" } ] }, { "featureType": "poi", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "visibility": "off" }, { "color": "#484848" } ] }, { "featureType": "transit", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "labels.icon", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "elementType": "all", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "elementType": "labels.text.fill", "stylers": [ { "saturation": "0" }, { "lightness": "0" }, { "gamma": "1.00" }, { "weight": "1" } ] }, { "featureType": "transit.station.bus", "elementType": "labels.icon", "stylers": [ { "saturation": "-100" }, { "weight": "1" }, { "lightness": "0" } ] }, { "featureType": "transit.station.rail", "elementType": "all", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.rail", "elementType": "labels.text.fill", "stylers": [ { "gamma": "1" }, { "lightness": "40" } ] }, { "featureType": "transit.station.rail", "elementType": "labels.icon", "stylers": [ { "saturation": "-100" }, { "lightness": "30" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#d2d2d2" }, { "visibility": "on" } ] } ]; 

  map = new google.maps.Map(document.getElementById('map'), {
    center: {lat: 51.507351, lng: -0.127758},
    zoom: 2,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    zoomControl: false,
    styles: style,
    maxZoom: 10,
  });

  loadMapMarkers();

  }

  prepareFilters();

  /**
  * Uncheck countries/states when region selected
  */

  $('[data-location="region"]').on( 'click', function () {
    if ( $( '[data-location="country"]:checked' ) )
    {
      $('[data-location="continent"],[data-location="country"], [data-location="state"]').prop('checked', false);
      $('[data-continent]').hide();
    }
  });

  /**
  /* Clear Filter
  /**/

  $('.clear-filters').on('click', function(e) {
    e.preventDefault();
    $isotopeContainer.isotope({ filter: '*' });
    $('[data-filter]').prop('checked', false);
    $('.filter__continents, .filter__countries').hide();
    $('.partner__count').text( $isotopeContainer.data('isotope').filteredItems.length );
    $('.marker__count').text( $isotopeContainer.data('isotope').filteredItems.length );
    $('.clear-filters').hide();
  });

  /**
  * Load filters from URL hash
  */

  var hash = getHashFilters();

  if (hash)
  {

    var hashArray = hash.split(',');

    var region_element,
        continent_element,
        country_element,
        state_element;

    $.each( hashArray, function(key, value ) {

      var this_filter = $('[data-filter][value=".' + value + '"]');

      // Check parent filters for Region

      if (
        this_filter.data('location') == 'region'
        ||         
        this_filter.data('location') == 'continent'
        || 
        this_filter.data('location') == 'country'
        || 
        this_filter.data('location') == 'state'
        )
      {

        // Stats

        if (this_filter.data('location') == 'state')
        {
          state_element = this_filter;
        }

        // Country

        if (this_filter.data('location') == 'country')
        {
          country_element = this_filter;
        }
        else if (this_filter.data('location') == 'state')
        {
          country_element = $('[data-location="country"][value="' + this_filter.parents('[data-parent-country]').data('parent-country') + '"]');
        }

        // Continent

        if (this_filter.data('location') == 'continent')
        {
          continent_element = this_filter;
        }
        else if (this_filter.data('location') == 'country' || this_filter.data('location') == 'state')
        {
          continent_element = $('[data-location="continent"][value="' + country_element.parents('[data-continent]').data('continent') + '"]');
        }

        // Region

        if (this_filter.data('location') == 'region')
        {
          region_element = this_filter;
        }
        else if (this_filter.data('location') == 'continent' || this_filter.data('location') == 'country' || this_filter.data('location') == 'state')
        {
          region_element = $('[data-location="region"][value="' + continent_element.parents('[data-region]').data('region') + '"]');
        }

        $('.filter__continents[data-region="' + region_element.val() + '"').show();

        if (region_element) region_element.prop('checked', true);
        if (continent_element) continent_element.prop('checked', true);
        if (country_element) country_element.prop('checked', true); 
        if (state_element) state_element.prop('checked', true);

      }
      else
      {
        this_filter.prop('checked', true);
      }

      this_filter.trigger( 'change' );

    });
  }

});

/**
 * Solution Builder
 */

$(window).on('load', function() { 

  var $grid = $('[data-partners]').isotope({
    // options
    itemSelector: '.grid-item',
    layoutMode: 'fitRows',
  });

  var iso = $grid.data('isotope');
  var $filterCount = $('.solution-builder__count');

  $('.solution-builder__option').on( 'click', function(e) {
    e.preventDefault();
    var type = $(this).find('a').attr('href');
    var term = $(this).find('a').data('term');
    if ( !term )
    {
      term = $(this).find('div').data('term');
    }
    var link = $(this);

    if ( $(this).hasClass('solution-builder__option--region') )
    {
      $(this).addClass('selected').siblings().removeClass('selected');
    }
    else
    {
      $(this).toggleClass('selected');
    }

    // Option prompts

    var prompt = $('.solution-builder__content[data-term="'+ term +'"]');
    var next_question = $('.solution-builder__content').eq( $('.solution-builder__content').index( prompt ) + 1 )
    if ( prompt.data('term') != 'service' )
    {
      $('html, body').animate({scrollTop: $(next_question).offset().top});
    }

    var options = [];
    var regionQuery = [];
    var serviceQuery = [];
    var industryQuery = [];
    var filters = [];

    // // Loop through selected values. Add tag to array

    $('.solution-builder__option').filter('.selected').each(function() {
      var tag = $(this).find('a').data('tag');
      if ( !tag )
      {
        tag = $(this).find('div').data('tag');
      }
      var term = $(this).find('a').data('term');
      if ( !term )
      {
        term = $(this).find('div').data('term');
      }
      if ( term == 'region' )
      {
        regionQuery.push( tag );
        tag = '.' + tag;
        options.push( tag );
      }
      else if ( term == 'industry' )
      {
        industryQuery.push( tag );
      }
      else 
      {
        serviceQuery.push ( tag );
        tag = '.' + tag;
        options.push( tag );
      } 
      
    });

    // Display solution

    if ( $('.solution-builder__option--region').hasClass('selected') && $('.solution-builder__option--service').hasClass('selected') && $('.solution-builder__option--industry').hasClass('selected') )
    {
      $('.solution-builder__solution').fadeIn();
      $('html, body').animate({scrollTop: $('.solution-builder__solution').offset().top});
    }
    else
    {
      $('.solution-builder__solution').fadeOut();
    }

    // Combine filters

    var isotope_filter = regionQuery + serviceQuery;
    
    options = options.join('');

    $grid.isotope({ filter: options });
    $filterCount.text( iso.filteredItems.length );

    // Add URL hash to view partner button

    var all_filters = regionQuery + ',' + serviceQuery;

    if (all_filters.length)
    {
      $('.view-partners').attr('href', '/partners/#filters=' + all_filters );
    }
    else
    {
      $('.view-partners').attr('href', '/partners/' );
    }

    // Add options to form

    $('#vfb-field-39').val('[ Region: ' + regionQuery + ' ] [ Service: ' + serviceQuery + ' ] [ Requirements: ' + industryQuery + ' ] ');
    
  });
});


/**
 * Solution Builder contact form
 */

$('.schedule-call').on( 'click', function(e) {
  e.preventDefault();
  $('.section--subscribe--solution').slideDown( 500, function() {
    $('html, body').animate({scrollTop: $('.section--subscribe--solution').offset().top}, 200);
  });
});

$('.form-close').on( 'click', function() {
  $('.section--subscribe--solution').slideUp();
});

$(window).on('load', function() {
  if ( $('.solution-form-submitted').length )
  {
    $('.section--subscribe--solution').slideDown( 500, function() {
      $('html, body').animate({scrollTop: $('.section--subscribe--solution').offset().top}, 200);
    });
  }
});

/**
* Report sidebar positioning
*/

$(window).on( 'load', function() {
  if ( $('body').hasClass('page-template-template-report') )
  {
    var height = $('.section--hero').outerHeight();
    var difference = height - 96;
    $('.sidebar').css('margin-top', - difference);
    setTimeout ( function() {
      $('.sidebar').addClass('loaded');
    }, 200)
  }
});


/**
* Track sign up locations
*/
$('.single-post .section--subscribe--insights .btn.infusion-recaptcha').on('click', function() {
  console.log('Single Interstitial');
  ga('send', 'event', 'Subscription', 'submit', 'Single Interstitial');
});
$('.blog .section--subscribe--insights .btn.infusion-recaptcha').on('click', function() {
  console.log('Insights Interstitial');
  ga('send', 'event', 'Subscription', 'submit', 'Insights Interstitial');
});
$('.section--footer--insights .btn.infusion-recaptcha').on('click', function() {
  console.log('Footer');
  ga('send', 'event', 'Subscription', 'submit', 'Footer');
});

/**
* Fitvids
*/

fitvids();


/**
* Initialise map and markers
*/

var markers = [];
var map;
var show_logos;

function loadMapMarkers()
{

  var params = new URLSearchParams(window.location.search);

  if (params.has('logos'))
  {
    show_logos = true;
    $('#show_logos').prop('checked', true);
  }

  setMapOnAll(null);

  var infowindows = [],
  locations = $('#map').data('markers'),
  icon_url = $('#map').data('pin-icon'),
  style = [ { "featureType": "administrative", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [ { "saturation": "-100" }, { "lightness": "57" } ] }, { "featureType": "poi", "elementType": "geometry.stroke", "stylers": [ { "lightness": "1" } ] }, { "featureType": "poi", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "visibility": "off" }, { "color": "#484848" } ] }, { "featureType": "transit", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "labels.icon", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "elementType": "all", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "elementType": "labels.text.fill", "stylers": [ { "saturation": "0" }, { "lightness": "0" }, { "gamma": "1.00" }, { "weight": "1" } ] }, { "featureType": "transit.station.bus", "elementType": "labels.icon", "stylers": [ { "saturation": "-100" }, { "weight": "1" }, { "lightness": "0" } ] }, { "featureType": "transit.station.rail", "elementType": "all", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.rail", "elementType": "labels.text.fill", "stylers": [ { "gamma": "1" }, { "lightness": "40" } ] }, { "featureType": "transit.station.rail", "elementType": "labels.icon", "stylers": [ { "saturation": "-100" }, { "lightness": "30" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#d2d2d2" }, { "visibility": "on" } ] } ]; 

  var infowindow = new google.maps.InfoWindow();
  var bounds = new google.maps.LatLngBounds();

  for (var i = 0; i < locations.length; i++) { 

    var marker;

    if (show_logos === true)
    {
      var icon = {
        url: locations[i].pin,
        scaledSize: new google.maps.Size(50, 80),
        animation: google.maps.Animation.DROP,
        anchor: new google.maps.Point(25, 80),
      }
    }
    else
    {
      var icon = {
        url: icon_url,
        scaledSize: new google.maps.Size(25, 40),
        animation: google.maps.Animation.DROP,
        anchor: new google.maps.Point(12.5, 40),
      }
    }

    marker = new google.maps.Marker({
      map: map,
      draggable: false,
      animation: google.maps.Animation.DROP,
      position: { lat: locations[i].lat, lng: locations[i].lng },
      contentString: '<div style="width:200px;"><a href="' + locations[i].link + '"><img src="' + locations[i].logo + '" width="100" /></a><br /><br /><strong>' + locations[i].name + '</strong><br />' + locations[i].address + '</div>',
      icon: icon,
      regions: locations[i].regions,
      industries: locations[i].industries,
      services: locations[i].services,
      partners: locations[i].partner_slug,
      state: locations[i].state,
      custom_pin_url: locations[i].pin,
    });

    marker.addListener('click', function() {
      infowindow.setContent(this.contentString);
      infowindow.open(map, this);
    });

    markers.push(marker);

    bounds.extend( new google.maps.LatLng(locations[i].lat, locations[i].lng) );

  }

  map.fitBounds(bounds);

}

function updateMapMarkersIcons() { 

  var icon_url = $('#map').data('pin-icon');

  for (let i = 0; i < markers.length; i++) {

    if (show_logos === true)
    {
      var icon = {
        url: markers[i].custom_pin_url,
        scaledSize: new google.maps.Size(50, 80),
        animation: google.maps.Animation.DROP,
        anchor: new google.maps.Point(25, 80),
      }
    }
    else
    {
      var icon = {
        url: icon_url,
        scaledSize: new google.maps.Size(25, 40),
        animation: google.maps.Animation.DROP,
        anchor: new google.maps.Point(12.5, 40),
      }
    }


    markers[i].setIcon(icon);
  }
}

/**
* Sets the map for all markers in markers array
*/

function setMapOnAll(map) {
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(map);
  }
}

$('#show_logos').on('click', function() { 
  var url = window.location.href;
  if ($(this).is(':checked'))
  {
    show_logos = true;
    if (url.indexOf('logos') === -1)
    {
      url = url.replace('/map/', '/map/?logos');
    }
  }
  else
  {
    show_logos = false;
    if (url.indexOf('logos') !== -1)
    {
      url = ( url.match( /[\?]/g ) ? url.replace('?logos', '') : url.replace('&logos', '') );
    }  
  }
  history.pushState({}, null, url);
  updateMapMarkersIcons();
});

/**
* Get filters from URL
*/

function getHashFilters() {
  var hash = location.hash;
  var matches = location.hash.match( /filters=([^&]+)/i );
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent( hashFilter );
}


/**
 * Prepare Filters
 */

function prepareFilters() {

  // quick search regex
  var qsRegex;
  var buttonFilter;

  // init Isotope
  $isotopeContainer = $('[data-grid]').isotope({
    itemSelector: '.grid-item',
    layoutMode: 'fitRows',
    filter: function() {
      var $this = $(this);
      var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
      var filterResult = buttonFilter ? $this.is( buttonFilter ) : true;
      return searchResult && filterResult;
    }
  });

  $isotopeContainer.addClass('loaded');

  var iso = $isotopeContainer.data('isotope');
  var $filterCount = $('.partner__count');
  // Filter using checkboxes
  $('[data-filter]', '.section--partner-archive').off('change').on('change', function() {
    var $container = $(this).parents('[data-tab-content]'),
      tab = $container.data('tab-content'),
      count = $container.find('input:checked').length,
      filters = [],
      countries = [],
      state = [],
      industries = [],
      services = [],
      partners = [],
      filters_regions = [],
      filters_industries = [],
      filters_services = [],
      filters_partners = [];

    $('[data-tab="' + tab + '"]').find('.partner__count').text(count);

    if ( count ) {
      $('.clear-filters').fadeIn();
    } else {
      $('.clear-filters').hide();
    }

    $('[data-location="region"]').filter(':checked').each(function() {
      var region = $(this).val();
      var region_target = $('[data-region="'+ region +'"]');
      region_target.show();
      $('[data-region]').not(region_target).hide();
      $('[data-region]').not(region_target).find('[data-location="continent"]').prop('checked', false);
      $('[data-region]').not(region_target).find('[data-location="continent"]').prop('checked', false);
    });

    $('[data-location="continent"]').filter(':checked').each(function() {
      var continent = $(this).val();
      
      if ( continent == '.canada' )
      {
        $('input[data-parent=".united-states"]').prop('checked', false);
      }
      var continent_target = $('[data-continent="'+ continent +'"]');
      continent_target.show();
      $('[data-continent]').not(continent_target).hide();
      $('[data-continent]').not(continent_target).find('[data-location="country"]').prop('checked', false);
    });

    $('[data-location="country"]').filter(':checked').each(function() {
      countries.push( this.value.replace('.', '') );

      /**
      * Show state ul when country checked
      */

      var country = $(this).val();
      var state_target = $('[data-parent-country="'+ country +'"]');
      state_target.show();
      $('[data-state]').not(state_target).hide();

    });

    /**
    * Uncheck countries, except parent, when state selected
    */

    $('[data-location="state"]').filter(':checked').each(function() {
      state.push( this.value.replace('.', '') );
      var parent = $(this).data('parent');
      var country = $('[data-location="country"]');
      $('[data-location="country"]').each(function() {
        if ( $(this).val() != parent )
        {
          $(this).prop('checked', false);
        }
      });
    });

    $('[data-location="region"], [data-location="continent"], [data-location="country"], [data-location="state"]').filter(':checked').each(function() {
      filters_regions.push(this.value);
    });

    $('[data-filter="industry"]').filter(':checked').each(function() {
      filters_industries.push(this.value);
      industries.push( this.value.replace('.', '') );
    });

    $('[data-filter="service"]').filter(':checked').each(function() {
      filters_services.push(this.value);
      services.push( this.value.replace('.', '') );
    });

    $('[data-filter="partner"]').filter(':checked').each(function() {
      filters_partners.push(this.value);
      partners.push( this.value.replace('.', '') );
    });

    var filters_combined = '';

    // start filtering
    
    if ($(this).data('location') == 'region') 
    {          
      $('input[data-location="continent"]:checked, input[data-location="country"]:checked, input[data-location="state"]:checked').each(function() { 

        var index = filters_regions.indexOf(this.value);
        filters_regions.splice(index, 1);

      });
    } 
    else 
    {

      if ( $('[data-location="state"]:checked').length > 0 ) 
      {
        // If filtering by state, ignore region, continent and country

        $('input[data-location="region"]:checked, input[data-location="continent"]:checked, input[data-location="country"]:checked').each(function() { 

          var index = filters_regions.indexOf(this.value);
          filters_regions.splice(index, 1);

        });

      } 
      else if ( $('[data-location="country"]:checked').length > 0 ) 
      {

        // If filtering by country, ignore region and continent

        $('input[data-location="region"]:checked, input[data-location="continent"]:checked').each(function() { 

          var index = filters_regions.indexOf(this.value);
          filters_regions.splice(index, 1);

        });

      } 
      else if ( ($('[data-location="continent"]:checked').length > 0) && ($('[data-location="country"]:checked').length == 0) ) 
      {

        // If filtering by region, ignore continent

        $('input[data-location="region"]:checked').each(function() { 

          var index = filters_regions.indexOf(this.value);
          filters_regions.splice(index, 1);

        });
      }
    }

    $('[data-location="country"]').on( 'click', function () {
      if ( $( '[data-location="state"]:checked' ).length > 0 )
      {
        $('[data-location="state"]').prop('checked', false);
      }
      if ( $('.filter__states').is(':visible') )
      {
        $('.filter__states').hide();
      }
    });

    // Combine service and industry filters

    filters_combined = filters_services.concat(filters_industries, filters_partners);
    
    filters_combined = filters_combined.join('');

    // Append service and industry filters to list of regions if at least one region is selected

    if (filters_regions.length > 0) 
    {

      for (var i = 0; i < filters_regions.length; i++) { 
        
        filters.push(filters_regions[i] + filters_combined);
        
      }

    } 
    else 
    {

      // If no region is selected then filter by just services, industries and partners (map view)

      filters.push(filters_combined);

    }

    var mapfilters = {
      'regions': filters_regions,
      'services': filters_services,
      'industries': filters_industries,
      'partners': filters_partners,
    }

    filterMapMarkers(mapfilters);

    buttonFilter = filters.join(', ');

    if (filters[0] != '')
    {
      $isotopeContainer.isotope({ filter: filters }); 
    }

    if ( iso )
    {
      $filterCount.text( iso.filteredItems.length );
    }

    // Update URL hash

    var all_filters = filters_regions + filters_industries + filters_services + filters_partners;

    if (all_filters.length)
    {
      var filters_string = all_filters.replaceAll(',', '');
      filters_string = filters_string.replaceAll('.', ',');
      location.hash = 'filters=' + filters_string.substr(1);
    }
    else
    {
      location.hash = '';
    }

  });

  // Trigger pre-populated checkboxes on load

  var search = location.search;
  if (search.length)
  { 

    var regions = search.split('?region=').pop().split('&?service=')[0];
    var services = search.split('?service=')[1];

    if (regions)
    {
      for ( var i = 0; i < regions.length; i++ )
      {
        var region = regions.split('&')[i];
        $(':radio[value=".'+ region +'"]').trigger('click');
      }
    }

    if (services)
    {
    for ( var i = 0; i < services.length; i++ )
      {
        var service = services.split('&')[i];
        $('[value=".'+ service +'"]').trigger('click');
      }
    }

    // $('[data-filter-option="service"]').addClass('active');
    // $('[data-tab-content="service"]').addClass('active').slideDown();

  }

}

/**
* Function to filter map markers by category
*/

Array.prototype.diff = function(arr2) {
  var ret = [];
  this.sort();
  arr2.sort();
  for(var i = 0; i < this.length; i += 1) {
      if(arr2.indexOf(this[i]) > -1){
          ret.push(this[i]);
      }
  }
  return ret;

};

function filterMapMarkers(filters)
{

  var $markerCount = $('.marker__count');

  if (typeof markers === 'undefined') return false;

    // Create array from filters

    for (var i = 0; i < markers.length; i++) {

      var marker = markers[i];

      $.each(filters, function( type, values ) {

        if (values.length == 0) return true;

        if (type == 'regions')
        {
          var tags = marker.regions.split(' ');
          var values = filters.regions.map(function(x){ return x.replace('.','') });
          var matches = tags.diff(values);

          if ( matches.length > 0 )
          {
            marker.setVisible(true);
          }
          else
          {
            marker.setVisible(false);
            return false;
          }
        }
        else if ( type == 'services' )
        {
          var tags = marker.services.split(' ');
          var values = filters.services.map(function(x){ return x.replace('.','') });
          var matches = tags.diff(values);

          if ( matches.length == values.length )
          {
            marker.setVisible(true);
          }
          else
          {
            marker.setVisible(false);
            return false;
          }
        }
        else if ( type == 'partners' )
        {
          var tags = marker.partners.split(' ');
          var values = filters.partners.map(function(x){ return x.replace('.','') });
          var matches = tags.diff(values);

         if ( matches.length > 0 )
          {
            marker.setVisible(true);
          }
          else
          {
            marker.setVisible(false);
            return false;
          }
        }
        else if ( type == 'industries' )
        {
          var tags = marker.industries.split(' ');
          var values = filters.industries.map(function(x){ return x.replace('.','') });
          var matches = tags.diff(values);

          if ( matches.length == values.length )
          {
            marker.setVisible(true);
          }
          else
          {
            marker.setVisible(false);
            return true;
          }
        }
    });

    // Adjust map bounds to show all pins

    var markerCount = 0;  
    var bounds = new google.maps.LatLngBounds();

    $.each(markers, function (i, marker) {
      if (marker.visible == true) {
        markerCount++;
        bounds.extend( new google.maps.LatLng(marker.position.lat(), marker.position.lng()) );
      }
    });

    map.fitBounds(bounds);
    map.panToBounds(bounds);

    $markerCount.text( markerCount );
    
  }

  $('.clear-filters').on('click', function(e) {
    $('.filter__states').hide();
    if ($('#map').length)
    {
      var bounds = new google.maps.LatLngBounds();
      for (i = 0; i < markers.length; i++) {
        var marker = markers[i];
        $.each(filters, function( type, values ) {
          marker.setVisible(true);
          bounds.extend( new google.maps.LatLng(marker.position.lat(), marker.position.lng()) );
        });
      }
      map.fitBounds(bounds);
      map.panToBounds(bounds);
      location.hash = '';
    }
  });

  /**
  * Clear filters if all data-filters are unchecked
  */

  $('[data-filter]').on( 'click', function () {

    $('.filter__states').hide();

    if ($('[data-filter]:checked').length == 0)
    {
      $isotopeContainer.isotope({ filter: '*' });
      $('.partner__count').text( $isotopeContainer.data('isotope').filteredItems.length );

      for (i = 0; i < markers.length; i++) 
      {
        var marker = markers[i];
        $.each(filters, function( type, values ) 
        {
          marker.setVisible(true);
        });
      }
    }
  });
}



/**
* Vacancy filter
*/

$(window).on('load', function() { 

  var $grid = $('.vacancies__grid').isotope({
    // options
    itemSelector: '.grid-item',
    layoutMode: 'fitRows',

  });

  var iso = $grid.data('isotope');
  var $filterCount = $('.vacancies__active-count');
  var max_count = $('.vacancies__max-count');

  $grid.addClass('loaded');

  $('[data-filter]', '.vacancies__filter').off('change').on('change', function() {
    var $container = $(this).parents('[data-tab-content]'),
      tab = $container.data('tab-content'),
      count = $('.vacancies__filter').find('input:checked').length,
      filters = [],
      type = [],
      locales = [],
      roles = [],
      filters_type = [],
      filters_locales = [],
      filters_roles = [];

    $('[data-tab="' + tab + '"]').find('.vacancies__active-count').text(count);

    if ( count ) 
    {
      $('.vacancies__clear-filters').fadeIn();
    } 
    else
    {
      $('.vacancies__clear-filters').hide();
    }

    $('[data-filter="type"]').filter(':checked').each(function() {
      filters_type.push(this.value);
      type.push( this.value.replace('.', '') );
    });

    $('[data-filter="locale"]').filter(':checked').each(function() {
      filters_locales.push(this.value);
      locales.push( this.value.replace('.', '') );
    });

    $('[data-filter="role"]').filter(':checked').each(function() {
      filters_roles.push(this.value);
      roles.push( this.value.replace('.', '') );
    });

    var filters_combined = '';

    // Combine type, locale and role filters

    filters_combined = filters_type.concat(filters_locales, filters_roles);

    var filters_string = JSON.stringify(filters_combined).replaceAll(',', '').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
    
    if (filters[0] != '')
    {
      $grid.isotope({ filter: filters_string }); 
    }

    if ( iso )
    {
      $filterCount.text( iso.filteredItems.length );
    }

  });

  /**
    * Clear filters
    */

    $('.vacancies__clear-filters').on('click', function(e) {
      e.preventDefault();
      $grid.isotope({ filter: '*' });
      $('.vacancies__active-count').text( $grid.data('isotope').filteredItems.length );
      $('input[data-filter]').prop('checked', false);
      $(this).fadeOut();
    });

    /**
    * Clear filters if all data-filters are unchecked
    */

    $('[data-filter]').on( 'click', function () {

    if ($('[data-filter]:checked').length == 0)
    {
      $grid.isotope({ filter: '*' });
      $('.vacancies__active-count').text( $grid.data('isotope').filteredItems.length );
      $('.vacancies__clear-filters').hide();
    }

  });

});